import React, { useCallback, useEffect, useState } from 'react';

import { ExtraItemEnum } from 'enums';
import { getSelectedFilterValues } from 'utils/filterUtils';
import { CustomerSearchResponseModel } from 'api/backofficeApiClient';
import { getCustomersForTimesheetStatusReport } from 'redux/reducers/homeDashboardSlice';
import { TimesheetStatusReportFilters } from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/TimesheetStatusReportFilter/TimesheetStatusReportFilter';
import { TimesheetStatusReportFilterTypes } from '../enums';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  isAdmin?: boolean;
  filters: TimesheetStatusReportFilters;
  onChange: (data: TimesheetStatusReportFilters) => void;
};

export default function CustomerFilter(props: Props) {
  const { filters, onChange, isAdmin } = props;
  const dispatch = useAppDispatch();
  const [customers, setCustomers] = useState<CustomerSearchResponseModel[]>([]);
  const [isCustomersLoaded, setIsCustomersLoaded] = useState(false);

  const loadCustomers = useCallback(async () => {
    const result = await dispatch(
      getCustomersForTimesheetStatusReport(isAdmin),
    );

    if (getCustomersForTimesheetStatusReport.fulfilled.match(result)) {
      setCustomers(result.payload);
    }

    setIsCustomersLoaded(true);
  }, [dispatch, isAdmin]);

  useEffect(() => {
    loadCustomers();
  }, [loadCustomers]);

  const handleFilterChange =
    (type: TimesheetStatusReportFilterTypes) => (customers: string[]) => {
      const selectedFilterValues = getSelectedFilterValues(
        customers,
        ExtraItemEnum.All,
      );

      onChange({
        ...filters,
        [type]: selectedFilterValues,
      });
    };

  return (
    <SelectWithLoading
      isLoading={!isCustomersLoaded}
      optionLabelProp="label"
      className="full-width"
      value={filters[TimesheetStatusReportFilterTypes.Customer]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a customer"
      onChange={handleFilterChange(TimesheetStatusReportFilterTypes.Customer)}
      showSearch
      data-id="customerFilterField"
    >
      {isCustomersLoaded && (
        <>
          <SelectWithLoading.Option
            key={ExtraItemEnum.All}
            value={ExtraItemEnum.All}
          >
            <div>
              <div>{ExtraItemEnum.All}</div>
            </div>
          </SelectWithLoading.Option>
          {customers.map(
            ({
              customerId,
              companyName,
              customerKey,
            }: CustomerSearchResponseModel) => (
              <SelectWithLoading.Option
                key={customerId}
                value={customerId || ''}
                label={companyName}
              >
                {`${companyName} ${customerKey}`}
              </SelectWithLoading.Option>
            ),
          )}
        </>
      )}
    </SelectWithLoading>
  );
}
